import React from "react";
import { Tag } from "antd";

function prettifyStatus(status) {
    if (!status) return "-";
    return String(status)
        .toLowerCase()
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
}

export default function RequestStatusTag({ status }) {
    const colorMap = {
        SUBMITTED: "processing",
        REVIEWED: "warning",
        APPROVED: "success",
        REJECTED: "error",
        EMPTY: "default",
    };

    return <Tag color={colorMap[status] || "default"}>{prettifyStatus(status)}</Tag>;
}
